import React, { Component, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label } from 'semantic-ui-react'
import { withRouter, Route, Switch } from 'react-router'

import { updateProject } from '../actions'

import { fetchItem, setSideHidden } from '../actions'
import TestEvents from '~/common/testEvents'
import OrganizationCard from '~/organization/views/card'
import ProjectEdit from './edit'
import NotesCard from './notesCard'
import Editor from './editor'

const { Column } = Grid

let statusText = {
  order: 'Tilaus',
  production: 'Tuotannossa',
  archived: 'Arkistoitu',
}

class ProjectViewContainer extends Component {
  componentDidMount = () => {
    let { fetchItem, match } = this.props
    fetchItem(match.params.project_id)
  }

  componentWillUnmount() {
    this.props.resetItem()
  }

  render() {
    let { project, loading, error, updateProject, sideHidden, setSideHidden, history } = this.props

    sideHidden = false

    let projectId = project.get('id')
    let status = project.get('status')

    let contentClasses = ['datapage-content']
    if (sideHidden) contentClasses.push('datapage-content--sidehidden')

    let notificationsEnabled = project.getIn(['data', 'productionNotificationsEnabled']) === true

    return (
      <div className="datapage">
        <div className="datapage-header">
          <div className="datatable-header-actions">
            {loading ? (
              <span className="datatable-header-action datatable-header-action--icon">
                <Icon name="spinner" loading />
              </span>
            ) : (
              <Fragment>
                <a
                  href="#"
                  className="datatable-header-action datatable-header-action--icon"
                  onClick={e => e.preventDefault() & history.goBack()}>
                  <Icon name="chevron left" />
                </a>
                <span className="datatable-header-title">{project.get('name')}</span>
                <span className="datatable-header-item">
                  <span className="datatable-header-label">{statusText[status] || status}</span>
                </span>
                <span className="datatable-header-item">
                  <span className="datatable-header-label">
                    <Icon name={notificationsEnabled ? 'check' : 'times'} />
                    {notificationsEnabled ? 'Automaattiviestit päällä' : 'Automaattiviestit ei päällä'}
                  </span>
                </span>
                <Link to={`/organization/${project.getIn(['organization', 'id'])}`} className="datatable-header-action">
                  <Icon name="building" />
                  {project.getIn(['organization', 'name'])}
                </Link>
              </Fragment>
            )}
          </div>
        </div>
        <div className={contentClasses.join(' ')}>
          {loading ? (
            <div className="datapage-content-loading">Ladataan...</div>
          ) : error ? (
            <div className="datapage-content-error">{error}</div>
          ) : (
            <div className="datapage-content-main">
              <Editor project={project} updateProject={updateProject} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    project: state.activeProject || Map(),
    loading: state.activeProjectLoading,
    error: state.activeProjectError,
    sideHidden: state.projectViewSideHidden || false,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchItem: id => dispatch(fetchItem(id)),
    updateProject: values => dispatch(updateProject(values)),
    setSideHidden: hidden => dispatch(setSideHidden(hidden)),
    resetItem: () => dispatch({ type: 'PROJECT_FETCH_ITEM_RESET' }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectViewContainer)
